export default "__VITE_ASSET__BODW0Mlm__"